import React, { useEffect, useState } from 'react';
import AOS from 'aos';
import { TESTIMONIALS_CONTENT, TESTIMONIALS } from './Testimonials.js';
import './Testimonials.css';

const getInitials = (name) => {
  const parts = name.split(' ');
  return (parts[0][0] + (parts[1]?.[0] || '')).toUpperCase();
};

const Star = ({ index }) => (
  <svg className="rv__star" viewBox="0 0 24 24" style={{ animationDelay: `${index * 0.05}s` }}>
    <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
  </svg>
);

const Testimonials = () => {
  const [expanded, setExpanded] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 560);
  const initialCount = isMobile ? 3 : 6;

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 560);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    AOS.refresh();
  }, [expanded]);

  const displayItems = !expanded
    ? TESTIMONIALS.slice(0, initialCount)
    : TESTIMONIALS;

  return (
    <section className="rv rt__section">
      <div className="rt__container">
        <div className="rv__header">
          <h2 className="rv__heading" data-aos="fade-up">What Our <span className="text-gradient">Partners Say</span></h2>
          <p className="rv__subheading" data-aos="fade-up" data-aos-delay="50">{TESTIMONIALS_CONTENT.subheading}</p>
        </div>

        <div className="rv__grid" data-aos="fade-up">
          {displayItems.map((item) => (
            <div key={item.id} className="rv__card">
              <div className="rv__stars">
                {Array.from({ length: item.rating }).map((_, i) => (
                  <Star key={i} index={i} />
                ))}
              </div>
              <p className="rv__review">&ldquo;{item.review}&rdquo;</p>
              <div className="rv__person">
                <div className="rv__avatar">{getInitials(item.name)}</div>
                <div className="rv__info">
                  <span className="rv__name">{item.name}</span>
                  <span className="rv__role">{item.role}</span>
                  <span className="rv__location">{item.country}</span>
                </div>
              </div>
            </div>
          ))}
        </div>

        {TESTIMONIALS.length > initialCount && (
          <div className="rv__action">
            <button className="rt__btn rt__btn-primary" onClick={() => setExpanded(!expanded)}>
              {expanded ? 'View Less' : 'View More'}
            </button>
          </div>
        )}
      </div>
    </section>
  );
};

export default Testimonials;
